import React from 'react'

import { Box, Color, FontFamily, Space, Text } from '@gousto-internal/citrus-react'

export type CWCHowItWorksCardLabelsProps = {
  stepNumber: number
  title: string
  body: string
}

// Join the last two words with a non-breaking space (U+00A0) so a single word never wraps onto its
// own line — if the final word would hang, the previous one drops with it (designer request).
const NON_BREAKING_SPACE = String.fromCharCode(160)
const avoidWidow = (text: string) => text.replace(/ (\S+)\s*$/, `${NON_BREAKING_SPACE}$1`)

/** The step number + title + body that sit below every How It Works card figure. */
export function CWCHowItWorksCardLabels({ stepNumber, title, body }: CWCHowItWorksCardLabelsProps) {
  return (
    <Box>
      {/* Step heading — Axiforma Bold, Citrus font scale size 7 (20/28), ColdGrey_800 (#333D47).
          The numbered "1." prefix is part of the heading per Figma. */}
      <Text size={7} color={Color.ColdGrey_800} fontFamily={FontFamily.Bold}>
        {avoidWidow(`${stepNumber}. ${title}`)}
      </Text>
      <Space size={1} />
      {/* Step body — Axiforma Book, size 4 (16/24), ColdGrey_800. */}
      <Text size={4} color={Color.ColdGrey_800} fontFamily={FontFamily.Book}>
        {avoidWidow(body)}
      </Text>
    </Box>
  )
}
